import { render, staticRenderFns } from "./BookListItem.vue?vue&type=template&id=3d5f0c5b&scoped=true&"
import script from "./BookListItem.vue?vue&type=script&lang=js&"
export * from "./BookListItem.vue?vue&type=script&lang=js&"
import style0 from "./BookListItem.vue?vue&type=style&index=0&id=3d5f0c5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f0c5b",
  null
  
)

export default component.exports